var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsFullSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5C0.0260417 8.625 0.481771 6.94531 1.36719 5.46094C2.2526 3.95052 3.45052 2.7526 4.96094 1.86719C6.44531 0.981771 8.125 0.526042 10 0.5C11.875 0.526042 13.5547 0.981771 15.0391 1.86719C16.5495 2.7526 17.7474 3.95052 18.6328 5.46094C19.5182 6.94531 19.974 8.625 20 10.5C19.974 12.375 19.5182 14.0547 18.6328 15.5391C17.7474 17.0495 16.5495 18.2474 15.0391 19.1328C13.5547 20.0182 11.875 20.474 10 20.5C8.125 20.474 6.44531 20.0182 4.96094 19.1328C3.45052 18.2474 2.2526 17.0495 1.36719 15.5391C0.481771 14.0547 0.0260417 12.375 0 10.5ZM14.5312 8.78125C14.7396 8.54688 14.8438 8.28646 14.8438 8C14.8438 7.71354 14.7396 7.45312 14.5312 7.21875C14.2969 7.01042 14.0365 6.90625 13.75 6.90625C13.4635 6.90625 13.2031 7.01042 12.9688 7.21875L8.75 11.4375L7.03125 9.71875C6.79688 9.51042 6.53646 9.40625 6.25 9.40625C5.96354 9.40625 5.70312 9.51042 5.46875 9.71875C5.26042 9.95312 5.15625 10.2135 5.15625 10.5C5.15625 10.7865 5.26042 11.0469 5.46875 11.2812L7.96875 13.7812C8.20312 13.9896 8.46354 14.0938 8.75 14.0938C9.03646 14.0938 9.29688 13.9896 9.53125 13.7812L14.5312 8.78125Z",
    fill: "#00C9A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFullSuccess);
export default __webpack_public_path__ + "static/media/icons_full_success.3e0034b1.svg";
export { ForwardRef as ReactComponent };